import React, { Component } from 'react'
import styled from 'styled-components'

class Popup extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: this.props.open,
    }

    this.closeModal = this.closeModal.bind(this)
    this.openModal = this.openModal.bind(this)
  }

  closeModal() {
    this.setState( { open: false } )
    setTimeout(() => {
      if(this.props.onClose) this.props.onClose()
    }, 500);
  }

  openModal() {
    this.setState( { open: true } )
  }

  componentDidUpdate(prevProps) {
    if (prevProps.open !== this.props.open)
      this.setState({ open: this.props.open })
  }

  render() {

    return (
      <div>
        <PopupBackground open={this.state.open} onClick={ this.props.dismissable && this.closeModal}/>
        <PopupContainer
          width={this.props.width}
          height={this.props.height}
          open={this.state.open}
          centered={this.props.centered}
        >
          { this.props.children }

        </PopupContainer>
      </div>
    )
  }
}

export default Popup;

const PopupContainer = styled.div `
  width: ${props => props.width};
  height: ${props => props.height};
  background-color: white;
  color: black;
  text-align: center;

  position: fixed;
  ${'' /* left: calc(100vw * 0.05); */}
  right: 16px;
  padding: 16px 45px;
  overflow-x: hidden;
  overflow-y: auto;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  text-align: center;
  border: 1px solid rgba(0,0,0,0.15);
  z-index: 1040;
  transition: all .5s cubic-bezier(.8,-.25,.2,1.25);

  bottom: ${props => props.open ? props.centered ? '50%' : '16px' : '-100%'};
  max-height: calc(100vh - 32px);
  max-width: calc(100vw - 32px);

  ${ props => props.centered && `
    right: 50%;
    transform: translate(50%, 50%);

  `}
`

const PopupBackground = styled.div `
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  background-color: black;
  opacity: ${props => props.open ? '0.4' : '0.0'};
  visibility: ${props => props.open ? 'visible' : 'hidden'};
  transition: opacity .5s linear, visibility .5s linear;
  z-index: 1030;
`

PopupContainer.defaultProps = {
    width: "300px",
    height: "300px",
}



// WEBPACK FOOTER //
// /src/components/internal/Popups/Popup.js